import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import AtenaItemsCard from '@/components/formats/AtenaItemsCard.vue'
import AtenaPaperSelectCard from '@/components/formats/AtenaPaperSelectCard.vue'
import CompletedOutputPanel from '@/components/format-edit/completed/CompletedOutputPanel.vue'
import {
  ATENA_CHAR_LIMITS,
  ATENA_MAX_ITEMS,
  createAtenaItem,
  createEmptyAtenaFormatData,
  isAtenaLSize,
  normalizeAtenaFormatData,
  type AtenaFormatData
} from '@/utils/format-edit/atenaFormat'
import paperOptions from '@/utils/format-edit/atenaPaperOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'AtenaEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {



const { formLib, deviceLib } = useHostServices()

const mode = process.env.VUE_APP_MODE

const { formatData } = useFormatLocalData<AtenaFormatData>({
  saveName: 'atena',
  createEmpty: createEmptyAtenaFormatData
})

// ロード（初回・backup-loaded 再ロード）後の正規化。
// 正常値には何もしないため deep watcher で常時かけても収束する
watch(
  formatData,
  () => {
    normalizeAtenaFormatData(formatData)
    if (!formatData.createDate) {
      formatData.createDate = formLib.getToday()
    }
  },
  { deep: true, immediate: true }
)

const firstNameInput = ref(null)

const isLSize = computed(() => isAtenaLSize(formatData.selectedPaper))

// 宛名の最大入力件数。L判はシール紙1枚(宛先2面+差出人2面)のため2件まで
const maxAtenaItems = computed(() =>
  isLSize.value ? ATENA_MAX_ITEMS.lsize : ATENA_MAX_ITEMS.portrait
)

// AtenaPreview と同じ上限値を共有（atenaFormat.ts が単一の正）
const charLimits = computed(() =>
  isLSize.value ? ATENA_CHAR_LIMITS.lsize : ATENA_CHAR_LIMITS.portrait
)

const senderAddressText = computed(() =>
  [formatData.address1, formatData.address2].filter(Boolean).join('\n')
)
const senderAddressLength = computed(() => senderAddressText.value.length)
const isSenderAddressOver = computed(
  () => senderAddressLength.value > charLimits.value.address
)

function cleanUpPostNumber(value: string | undefined) {
  if (!value) return ''
  return String(formLib.zenToHanNumber(value.replace(/-/g, '')))
}

function selectOption(id: string) {
  formatData.selectedPaper = id
}

function addAtenaItem() {
  if (formatData.atenaItems.length >= maxAtenaItems.value) {
    return
  }
  formatData.atenaItems.push(createAtenaItem())
}

function deleteAtenaItem(index: number) {
  formatData.atenaItems.splice(index, 1)
}

// PDFメール・ダウンロードボタンの再有効化（完了画面パネルが送信中に無効化する既存挙動の維持）
const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

emitter.on('basic-data-changed', dataChanged)
emitter.on('format-data-changed', dataChanged)

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

return { __sfc: true,formLib, deviceLib, mode, formatData, firstNameInput, isLSize, maxAtenaItems, charLimits, senderAddressText, senderAddressLength, isSenderAddressOver, cleanUpPostNumber, selectOption, addAtenaItem, deleteAtenaItem, mailPdfEnabled, downloadPdfEnabled, dataChanged, AtenaItemsCard, AtenaPaperSelectCard, CompletedOutputPanel, paperOptions }
}

})